<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-6">
      <app-text-input
        controlName="healthcareProviderId"
        placeholder="HP-{{ hpIdMaskConfig.mask }}"
        [maskConfig]="hpIdMaskConfig"
      ></app-text-input>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-search-type-group">
        <app-select-input
          class="form-search-type-select"
          #nameSearchOptionTypeList
          controlName="nameSearchOptionType"
          [showNullPlaceholder]="false"
        ></app-select-input>
        <app-generic-input
          class="form-search-type-input"
          approvedNameCharacters
          controlName="providerName"
          hint="Last, First OR SED Name"
        ></app-generic-input>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <app-generic-input controlName="nationalProviderIdentifier"></app-generic-input>
    </div>
    <div class="col-6">
      <app-generic-input controlName="licenseNumber"></app-generic-input>
    </div>
  </div>
</form>
